import { MVROption } from './types'

export const yardstikOption: MVROption = {
  value: 'yardstik',
  label: 'Use Yardstick to conduct Motor Vehicle Record Report',
}

export const manualOption: MVROption = {
  value: 'manual',
  label: 'I want to manually upload Motor Vehicle Record Report file',
}

export const skipOption: MVROption = {
  value: 'skip',
  label: 'I want to proceed without Motor Vehicle Record Report',
}
